import React,{lazy,Suspense} from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import WorkoutAuth from "./components/WorkoutAuth.jsx";
import PackagePaymentPage from "./components/PackagePaymentPage.jsx";
import PublicBookingPage from "./public/PublicBookingPage.jsx";
import "./index.css";
import SmsConsentPage from "./components/SmsConsentPage.jsx";
import EmailUnsubscribePage from './components/EmailUnsubscribePage.jsx';

const WaiverPage=lazy(()=>import('./public/WaiverPage.jsx'));
const SelfCheckoutPage=lazy(()=>import('./public/SelfCheckoutPage.jsx'));
const PurchaseStatusPage=lazy(()=>import('./public/PurchaseStatusPage.jsx'));

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/shop/purchases" element={<Suspense fallback={<p role="status">Checking purchase…</p>}><PurchaseStatusPage/></Suspense>}/>
        <Route path="/shop/:code" element={<Suspense fallback={<p role="status">Loading shop…</p>}><SelfCheckoutPage/></Suspense>}/>
        <Route path="/waivers" element={<Suspense fallback={<p role="status">Loading waiver…</p>}><WaiverPage/></Suspense>}/>
        <Route path="/email-unsubscribe" element={<EmailUnsubscribePage/>}/>
        <Route path="/sms-consent/:gymSlug" element={<SmsConsentPage />} />
        <Route path="/workout" element={<WorkoutAuth />} />
        <Route path="/pay/:token" element={<PackagePaymentPage />} />
        <Route path="/scheduling/:slug" element={<PublicBookingPage />} />
        <Route path="/book/:slug" element={<PublicBookingPage />} />
        <Route path="*" element={<Navigate to="/workout" replace />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </BrowserRouter>
  </React.StrictMode>
);
